import axios from 'axios'
import env from './env'

// Create and configure the axios instance
const restApi = axios.create({
  baseURL: env.apiUrl(),
  timeout: 30000
})

export default restApi
